import { Plot, PLOTLY_CONFIG_BASE, PLOTLY_LAYOUT_BASE } from "./plot";
import type { ScoreDecomposition } from "@/lib/api/types";

type Props = {
  rows: ScoreDecomposition[];
  height?: number;
};

export function DecompositionChart({ rows, height = 320 }: Props) {
  const sorted = [...rows].sort((a, b) => a.contribution_bps - b.contribution_bps);
  const labels = sorted.map((r) => r.factor_name);
  const values = sorted.map((r) => r.contribution_bps);
  const colors = values.map((v) =>
    v > 0 ? "#10b981" : v < 0 ? "#ef4444" : "#5e6772",
  );
  return (
    <Plot
      data={[
        {
          type: "bar",
          orientation: "h",
          x: values,
          y: labels,
          marker: { color: colors },
          hovertemplate: "%{y}<br>contribution: %{x:+.0f} bps<extra></extra>",
        } as never,
      ]}
      layout={{
        ...PLOTLY_LAYOUT_BASE,
        height,
        margin: { ...PLOTLY_LAYOUT_BASE.margin, l: 180 },
        xaxis: {
          ...PLOTLY_LAYOUT_BASE.xaxis,
          title: { text: "Contribution (bps)", standoff: 10 },
        },
        yaxis: {
          ...PLOTLY_LAYOUT_BASE.yaxis,
          automargin: true,
        },
      }}
      config={PLOTLY_CONFIG_BASE}
      style={{ width: "100%" }}
    />
  );
}
